import React, { useEffect, useState } from 'react';
import Terms from '../../../views/company/auth/Terms';
import {
  Dialog,
  DialogContent,
  IconButton,
  Button,
  Typography,
  Box,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { useNavigate } from 'react-router-dom';
import ServerURL from '../../../serverURL';
import JobQuickCreateModal from '../../../company-components/JobQuickCreateModal';

const ScoutPrereqModal = ({
  open,
  onClose,
  onComplete,
  companyRegistered,
  jobPublished,
  width = 460,
}) => {
  const navigate = useNavigate();
  const [quickCreateOpen, setQuickCreateOpen] = useState(false);
  const [quickJobId, setQuickJobId] = useState('');
  const [quickJobTitle, setQuickJobTitle] = useState('');
  const [termsOpen, setTermsOpen] = useState(false);

  const BUTTON_WIDTH = 120;

  useEffect(() => {
    if (open && companyRegistered && jobPublished) {
      onComplete && onComplete();
    }
  }, [open, companyRegistered, jobPublished, onComplete]);

  const handleClose = () => {
    localStorage.removeItem('first_login');
    onClose && onClose();
  };

  const handleQuickCreateOpen = () => {
    setQuickCreateOpen(true);
  };

  const handleQuickCreateClose = () => {
    setQuickCreateOpen(false);
  };

  const handleOpenTerms = () => {
    setTermsOpen(true);
  };
  const handleCloseTerms = () => {
    setTermsOpen(false);
  };

  if (!open || localStorage.getItem('register_expired') === '1') return null;

  const showTwoCards = !companyRegistered || !jobPublished;

  const companyButtonDisabled = companyRegistered;
  const jobButtonDisabled = !companyRegistered || jobPublished;

  let companyButtonLabel = '登録にすすむ';
  if (companyRegistered) {
    companyButtonLabel = '登録済​';
  }

  let jobButtonLabel = '登録にすすむ';
  if (jobPublished) {
    jobButtonLabel = '登録にすすむ';
  }

  const fetchJobs = (status, page, rowsPerPage, query, order, orderBy) => {
    console.log('Fetching jobs with status:', status);
  };

  const JobActiveStatus = 'active';
  const page = 0;
  const rowsPerPage = 10;
  const searchQuery = '';
  const order = 'asc';
  const orderBy = 'jobTitle';

  let headingText = '求人を作成しましょう！​';
  if (!companyRegistered) {
    headingText = '本契約へ切り替えるとスカウトが開始できます​';
  } else if (companyRegistered && !jobPublished) {
    headingText = '求人を掲載するとスカウトを開始できます​';
  }

  return (
    <>
      {/* ─── Main Modal ─── */}
      <Dialog open={open} onClose={handleClose} aria-labelledby="scout-prereq-dialog">
        <DialogContent
          sx={{
            textAlign: 'center',
            position: 'relative',
            pl: 5,
            pr: 5,
            pb: 5,
            width,
            backgroundColor: 'transparent',
          }}
        >
          <IconButton
            aria-label="close"
            onClick={handleClose}
            sx={{ position: 'absolute', right: 8, top: 8 }}
          >
            <CloseIcon />
          </IconButton>

          <Typography
            sx={{
              fontFamily: '"Noto Sans JP", sans-serif',
              fontSize: 19,
              fontWeight: 700,
              color: '#000',
              mt: 2,
            }}
          >
            {headingText}
          </Typography>

          {showTwoCards ? (
            <div
              style={{
                marginTop: 16,
                display: 'flex',
                flexDirection: 'column',
                gap: 1,
                alignItems: 'center',
              }}
            >
              {/* ─── 会社情報カード ─── */}
              <div
                style={{
                  borderRadius: 12,
                  padding: '14px 18px',
                  width: '100%',
                  maxWidth: 360,
                  backgroundColor: '#ffce5259',
                }}
              >
                <div
                  style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                  }}
                >
                  <div>
                    <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                      <Typography
                        sx={{
                          fontWeight: 700,
                          fontSize: 15,
                          fontFamily: '"Noto Sans JP", sans-serif',
                          textAlign: 'left',
                        }}
                      >
                        本契約への切替
                      </Typography>
                    </div>
                    <Typography
                      sx={{
                        fontSize: 12,
                        mt: 0.5,
                        color: '#000000ff',
                        fontFamily: '"Noto Sans JP", sans-serif',
                        textAlign: 'left',
                      }}
                    >
                      求職者に公開する会社情報等
                    </Typography>
                  </div>

                  <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                    {/* <div>
                      {companyRegistered && (
                        <Box
                          sx={{
                            width: '28px !important',
                            height: 28,
                            borderRadius: '50%',
                            border: '2px solid red',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                          }}
                        >
                          <Typography
                            sx={{
                              fontFamily: '"Noto Sans JP", sans-serif',
                              fontSize: 16,
                              fontWeight: 700,
                              color: 'red',
                              lineHeight: 1,
                            }}
                          >
                            済
                          </Typography>
                        </Box>
                      )}
                    </div> */}
                    <div>
                      <Button
                        variant="contained"
                        className="LightBlueButton"
                        disabled={companyButtonDisabled}
                        onClick={() => {
                          if (companyButtonDisabled) return;
                          handleClose();
                          navigate('/company/finalregistration');
                        }}
                        sx={
                          companyButtonDisabled
                            ? {
                                width: BUTTON_WIDTH,
                                backgroundColor: '#035a94 !important',
                                color: '#ffffff !important',
                                boxShadow: 'none',
                                cursor: 'not-allowed',
                                fontFamily: '"Noto Sans JP", sans-serif',
                              }
                            : {
                                width: BUTTON_WIDTH,
                                boxShadow: 'none',
                                fontFamily: '"Noto Sans JP", sans-serif',
                              }
                        }
                      >
                        {companyButtonLabel}
                      </Button>
                    </div>
                  </div>
                </div>
              </div>

              {/* Button between the two cards, right aligned */}
              <Box sx={{ width: '100%', display: 'flex', justifyContent: 'flex-end', mt: 1, mb: 1, ml:-10 }}>
                <Button
                  variant="contained"
                  onClick={handleOpenTerms}
                  sx={{
                    backgroundColor: "#3f79b8",   // blue like screenshot
                    color: "#fff",
                    fontFamily: '"Noto Sans JP", sans-serif',
                    fontSize: "10px",
                    lineHeight: 1.15,
                    px: 1.2,                     // horizontal padding
                    py: 0.6,                     // vertical padding
                    minWidth: 90,
                    borderRadius: "2px",
                    boxShadow: "none",
                    textTransform: "none",
                    "&:hover": {
                      backgroundColor: "#3f79b8",
                      boxShadow: "none",
                    },
                  }}
                >
                  利用規約
                  <br />
                  プライバシーポリシー
                </Button>
              </Box>

              {/* ─── 求人情報カード ─── */}
              <div
                style={{
                  borderRadius: 12,
                  padding: '14px 18px',
                  width: '100%',
                  maxWidth: 360,
                  background: '#ffce5259',
                }}
              >
                <div
                  style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                  }}
                >
                  <div>
                    <Typography
                      sx={{
                        fontWeight: 700,
                        fontSize: 15,
                        fontFamily: '"Noto Sans JP", sans-serif',
                        textAlign: 'left',
                      }}
                    >
                      求人掲載（スカウト開始）
                    </Typography>
                    <Typography
                      sx={{
                        fontSize: 12,
                        mt: 0.5,
                        color: '#222',
                        fontFamily: '"Noto Sans JP", sans-serif',
                        textAlign: 'left',
                      }}
                    >
                      求職者に公開する仕事情報
                    </Typography>
                  </div>
                  <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                    {/* <div>
                      {jobPublished && (
                        <Box
                          sx={{
                            width: '28px !important',
                            height: 28,
                            borderRadius: '50%',
                            border: '2px solid red',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                          }}
                        >
                          <Typography
                            sx={{
                              fontFamily: '"Noto Sans JP", sans-serif',
                              fontSize: 16,
                              fontWeight: 700,
                              color: 'red',
                              lineHeight: 1,
                            }}
                          >
                            済
                          </Typography>
                        </Box>
                      )}
                    </div> */}
                    <div>
                      <Button
                        variant="contained"
                        className="LightBlueButton"
                        disabled={jobButtonDisabled}
                        onClick={() => {
                          if (jobButtonDisabled) return;
                          handleQuickCreateOpen();
                        }}
                        sx={
                          jobButtonDisabled
                            ? {
                                width: BUTTON_WIDTH,
                                backgroundColor: '#05326eff !important',
                                color: '#ffffff !important',
                                boxShadow: 'none',
                                cursor: 'not-allowed',
                                fontFamily: '"Noto Sans JP", sans-serif',
                              }
                            : {
                                width: BUTTON_WIDTH,
                                boxShadow: 'none',
                                fontFamily: '"Noto Sans JP", sans-serif',
                              }
                        }
                      >
                        {jobButtonLabel}
                      </Button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ) : (
            <Typography
              sx={{
                fontFamily: '"Noto Sans JP", sans-serif',
                color: '#000',
                fontSize: 14,
                textAlign: 'center',
                marginTop: '8px',
              }}
            >
              全ての情報が登録済みです。
            </Typography>
          )}
        </DialogContent>
      </Dialog>

      {/* ─── Job Quick Create Modal ─── */}
      <JobQuickCreateModal
        open={quickCreateOpen}
        onClose={handleQuickCreateClose}
        jobUniqueCode={quickJobId}
        setJobUniqueCode={setQuickJobId}
        jobTitle={quickJobTitle}
        setJobTitle={setQuickJobTitle}
        onJobCreated={() =>
          fetchJobs(JobActiveStatus, page + 1, rowsPerPage, searchQuery, order, orderBy)
        }
      />

      {/* ─── Terms Modal ─── */}
      <Dialog
        open={termsOpen}
        onClose={handleCloseTerms}
        maxWidth={false}
        fullWidth
        PaperProps={{
          sx: {
            width: '90vw',
            height: '95vh',
            maxWidth: '90vw',
            maxHeight: '95vh',
            m: 0,
          },
        }}
      >
        <DialogContent sx={{ p: 0, height: '100%', position: 'relative', overflowY: 'auto' }}>
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'flex-end',
              pt: 2,
              pr: 2,
              position: 'sticky',
              top: 0,
              zIndex: 20,
              background: 'rgba(255,255,255,0.97)',
              borderBottom: '1px solid #eee',
            }}
          >
            <Button
              variant="outlined"
              size="small"
              sx={{ mr: 1, fontFamily: '"Noto Sans JP", sans-serif' }}
              onClick={async () => {
                try {
                  const apiUrl = `${ServerURL.PRODUCTION_HOST_URL}companies/download_privacy_policy_pdf`;
                  const response = await fetch(apiUrl, {
                    method: 'GET',
                  });
                  if (!response.ok) throw new Error('PDF download failed');
                  const blob = await response.blob();
                  const url = URL.createObjectURL(blob);
                  const a = document.createElement('a');
                  a.href = url;
                  a.download = '転ナビ 利用規約.pdf';
                  document.body.appendChild(a);
                  a.click();
                  document.body.removeChild(a);
                  URL.revokeObjectURL(url);
                } catch (err) {
                  alert('PDFのダウンロードに失敗しました。');
                }
              }}
            >
              ダウンロード
            </Button>
            <IconButton
              onClick={handleCloseTerms}
              sx={{
                ml: 1,
                backgroundColor: '#fff',
                '&:hover': { backgroundColor: '#f0f0f0' },
              }}
            >
              <CloseIcon />
            </IconButton>
          </Box>
          <Box id="terms-modal-content" sx={{ pt: 3, px: 3, pb: 3 }}>
            <Terms />
          </Box>
        </DialogContent>
      </Dialog>
    </>
  );
};

export default ScoutPrereqModal;